export default "__VITE_ASSET__CAx5GKRK__"